module.exports = __webpack_public_path__ + "img/hyu_gallery1.771379ad.jpg";